module.exports = __webpack_public_path__ + "59183cd88599e2a3eeac7c5adb731a02.ico";


//////////////////
// WEBPACK FOOTER
// ./src/static/favicon.ico
// module id = 589
// module chunks = 7